import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import Drawer from 'react-modern-drawer';
import classes from './Drawer.module.css';
const DrawerSkeleton = ({
  show,
  setShow,
  direction = 'right',
  size = '516px',
  children,
  parentClass,
  className
}) => {
  return (
    <Drawer
      open={show}
      onClose={setShow}
      direction={direction}
      size={size}
      style={{ height: '100vh' }}
      className={clsx(classes.mainDrawer, parentClass)}>
      <div className={clsx(classes.wrapper, className)}>{children}</div>
    </Drawer>
  );
};

DrawerSkeleton.propTypes = {
  direction: PropTypes.string,
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired
};

DrawerSkeleton.defaultProps = {
  direction: 'right',
  show: false,
  setShow: () => {}
};

export default DrawerSkeleton;
